import noAuthApiClient from '../http/noAuthApiClient';
export const getRecommendedHublet = () => {
  return noAuthApiClient.get('acquisition/v1/iplocation/hs-reg');
};